<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <ProjectManureSampleFormGroup
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            :addOns="addOns"
            :animalFedOptions="animal_fed_options"
          />
        </template>
      </div>
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectManureSampleFormGroup from "./ProjectManureSampleFormGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { validationMixin } from "vuelidate/src";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectManureSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectManureSampleFormGroup,
    TurnAroundSelect,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    addOns: {
      type: Array,
      default: () => [],
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
    managedLists: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
    animal_fed_options() {
      return this.createOptionList(
        this.managedLists.find(
          (item) => item.sub_type === "feed" && item.list === "animal_fed"
        ).attribute_lists,
        "animal_fed"
      );
    },
  },
  validations: {
    currentSubmission: {
      test_package_id: { required },
      turnaround_id: { required },
      samples: { required, minLength: minLength(1) },
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
    createOptionList(list, field) {
      return {
        options: list.map((item) => {
          return { id: item.id, name: item.value };
        }),
        field,
      };
    },
  },
};
</script>
